<template>
  <div style="width:2rem;height:2rem;line-height:2rem;text-align:center;background-color:#ff7c2c;color:#FFFFFF;margin:0 auto;" @click="clear"><span>清除缓存</span></div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        clear(){
            localStorage.removeItem('token')
            localStorage.removeItem('tenantNo')
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/timetable/test.vue